import React from 'react';
import Layout from '../../Components/Common/Layout';
import Profile from '../../Components/Profile';

const ProfilePage: React.FC = () => {
  return (
    <Layout title={'profilePage'}>
      <Profile />
    </Layout>
  );
};

export default ProfilePage;
